module.exports = __webpack_public_path__ + "img/Frame_32.edaebabe.png";